
import { VerticalLayout } from "../components/layout";
import { TailWindBadge } from "../atoms/badges";
import { IconAtom } from "../atoms/iconAtom";
import { TextAtom } from "../atoms/TextAtom";
export const JobTitle = ({ ruleTitle, ruleDescription, subCount, children }) => {
    return (
        <div onClick={(event) => event.stopPropagation()} className="w-full max-w-3xl rounded-2xl bg-slate-50 p-4">
            
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                    <IconAtom icon2={"job"} />

                    <VerticalLayout>
                        <TextAtom className="text-sm font-semibold text-slate-800"
                            title={ruleTitle}
                        />


                        <TextAtom className="text-xsm text-slate-500"
                            title={ruleDescription}
                        />


                    </VerticalLayout>
                </div>

                <TailWindBadge>{subCount} sub-regels</TailWindBadge>
            </div>


            <VerticalLayout className="gap-2">
                {children}
            </VerticalLayout>
        </div>
    )
}